import { render, staticRenderFns } from "./ConfiguracaoAgenda.vue?vue&type=template&id=b9da30a0&"
import script from "./ConfiguracaoAgenda.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoAgenda.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoAgenda.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports